type TgWebApp = {
  initData: string
  ready: () => void
  expand: () => void
  close: () => void
  MainButton: {
    show: () => void
    hide: () => void
    setText: (s: string) => void
    onClick: (cb: () => void) => void
    offClick: (cb: () => void) => void
    enable: () => void
    disable: () => void
  }
  showAlert: (s: string, cb?: () => void) => void
  showConfirm?: (s: string, cb: (ok: boolean) => void) => void
  themeParams: Record<string, string>
}

declare global {
  interface Window {
    Telegram?: { WebApp: TgWebApp }
  }
}

export function getTg(): TgWebApp | null {
  return typeof window !== 'undefined' ? window.Telegram?.WebApp ?? null : null
}

export function initTg(): TgWebApp | null {
  const tg = getTg()
  if (!tg) return null
  tg.ready()
  tg.expand()
  return tg
}

export function confirmAction(message: string): Promise<boolean> {
  return new Promise((resolve) => {
    const tg = getTg()
    if (tg?.showConfirm) tg.showConfirm(message, resolve)
    else resolve(window.confirm(message))
  })
}
